
import { FC } from 'react';
import { SearchIcon } from '@chakra-ui/icons';
import { Input, InputGroup, InputRightElement } from '@chakra-ui/react';
import { useTranslation } from 'helpers/languages/translations';

const GenericFilter: FC<{
    inputGroupStyles?: {
        [key: string]: string | number | boolean;
    };
    value?: string;
    onChange?: (value: string) => void;
}> = ({ value, inputGroupStyles, onChange }) => {

    const translate = useTranslation();
    return (
        <InputGroup size="sm" w="178px" mr="16px" {...inputGroupStyles}>
            <Input
                onChange={(e) => {
                    if (onChange)
                        onChange(e.target.value);
                }}
                bg="white"
                size="sm"
                value={value || ''}
                placeholder={translate('placeholder.search') as string}
            />
            <InputRightElement children={<SearchIcon />} />
        </InputGroup>
    );
};

export default GenericFilter
